import { jsx as i, jsxs as z, Fragment as v } from "react/jsx-runtime";
import q, { useState as B, useId as F, useEffect as P, cloneElement as w } from "react";
import { c as h } from "../clsx-OuTLNxxd.js";
import { A as R, E as U } from "../index-_mwUc74W.js";
import '../Accordion.css';const j = "320px", L = "600px", O = "1025px", D = "_header_4suny_33", G = "_splitHeader_4suny_37", J = "_iconSlot_4suny_43", K = "_heading_4suny_50", Q = "_toggle_4suny_57", X = "_triggerElement_4suny_66", Y = "_indicator_4suny_72", Z = "_trigger_4suny_66", M = "_contentElement_4suny_118", V = "_content_4suny_118", C = "_primary_4suny_138", N = "_secondary_4suny_141", ee = "_item_4suny_147", te = "_dense_4suny_147", ne = "_nav_4suny_240", ie = "_link_4suny_245", oe = "_headingText_4suny_277", ce = "_linkLabel_4suny_278", re = "_linkList_4suny_303", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: j,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: ie,
  headingText: oe,
  linkLabel: ce,
  linkList: re
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let s = 0;
  const c = requestAnimationFrame(() => {
    s = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(s);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: s = "xsm",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: y,
  stroke: W = "bold"
}) => {
  const [n, m] = B(c), x = d > 0, [u, _] = B(c), [p, a] = B(!!c), b = F(), g = F(), H = () => {
    y == null || y(!n), m(!n);
  };
  P(() => {
    c !== n && m(c);
  }, [c]), P(() => {
    if (!x) return;
    if (n)
      return _(!0), le(() => a(!0));
    a(!1);
    const r = setTimeout(() => _(!1), d);
    return () => clearTimeout(r);
  }, [n, x, d]);
  const f = {
    "aria-controls": g,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: b,
    onClick: H
  }, o = {
    "aria-labelledby": b,
    className: t.contentElement,
    hidden: x ? !u : !n,
    id: g,
    ...e ? { role: "region" } : {},
    ...x ? { "data-animated": "" } : {},
    ...x && p ? { "data-enter": "" } : {}
  };
  return {
    headingProps: f,
    sectionProps: o,
    triggerClass: t.triggerElement,
    Indicator: () => W === "bold" ? /* @__PURE__ */ i(R, { className: t.indicator, size: s }) : /* @__PURE__ */ i(U, { className: t.indicator, size: s })
  };
}, me = 300, se = ({
  animationDurationMs: d = 0,
  chevronStroke: s = "bold",
  children: c,
  classNames: e,
  heading: y,
  headingAs: W = "h3",
  icon: n,
  indicator: m,
  indicatorSize: x = "xsm",
  isDense: u = !1,
  isOpen: _ = !1,
  isPanelLandmark: p = !0,
  links: a,
  onChange: b,
  onLinkClick: g,
  testId: H,
  toggleLabel: f,
  trackingAttribute: o,
  variant: r
}) => {
  const { Indicator: l, headingProps: E, sectionProps: A, triggerClass: I } = de({
    animationDurationMs: d,
    isOpen: _,
    isPanelLandmark: p,
    onChange: b,
    indicatorSize: x,
    stroke: s
  }), T = {
    ...E,
    ...o ? { "data-analytics": o } : {},
    ...H ? { "data-testid": H } : {},
    type: "button"
  }, { id: $, ...k } = T;
  return /* @__PURE__ */ z(
    "div",
    {
      className: h(
        t.item,
        { [t.dense]: u },
        r && r !== "bare" && t[r],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ i(W, { className: h(t.header, { [t.splitHeader]: f }, e == null ? void 0 : e.header), children: f ? /* @__PURE__ */ z(v, { children: [
          /* @__PURE__ */ z("span", { className: h(t.heading, e == null ? void 0 : e.heading), id: $, children: [
            n !== void 0 && /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            y
          ] }),
          /* @__PURE__ */ i(
            "button",
            {
              "aria-label": f,
              className: h(I, t.toggle, e == null ? void 0 : e.button),
              ...k,
              children: m ?? /* @__PURE__ */ i(l, {})
            }
          )
        ] }) : /* @__PURE__ */ z("button", { className: h(I, t.trigger, e == null ? void 0 : e.button), ...T, children: [
          n === void 0 ? y : /* @__PURE__ */ z(v, { children: [
            /* @__PURE__ */ i("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ i("span", { className: h(t.headingText, e == null ? void 0 : e.heading), children: y })
          ] }),
          m ?? /* @__PURE__ */ i(l, {})
        ] }) }),
        /* @__PURE__ */ i(
          "div",
          {
            ...A,
            className: h(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: a ? /* @__PURE__ */ i("ul", { className: t.linkList, children: a.map((S) => /* @__PURE__ */ i("li", { children: /* @__PURE__ */ z("a", { className: t.link, href: S.href, onClick: () => g == null ? void 0 : g(S), children: [
              /* @__PURE__ */ i("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ i("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : c
          }
        )
      ]
    }
  );
}, xe = ({
  chevronStroke: d = "bold",
  children: s,
  defaultOpen: c,
  indicatorSize: e = "xsm",
  isDense: y = !1,
  name: W,
  onValueChange: n,
  type: m = "single",
  value: x,
  variant: u = "primary"
}) => {
  const _ = m === "multiple", p = x !== void 0, a = q.Children.toArray(s), b = c ? a.map(() => !0) : a.map((o) => !!o.props.isOpen), [g, H] = B(b), f = (o, r) => {
    let l = [];
    _ ? (l = [...g], l[r] = o) : (l = a.map(() => !1), o === !0 && (l[r] = !0)), H(l);
  };
  return /* @__PURE__ */ i(
    "div",
    {
      className: h(t.accordion, u !== "bare" && t[u]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: s && a.map(
        (o, r) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          w(o, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: y,
            variant: u,
            isOpen: p ? o.props.value === x : g[r],
            key: `${W}-item-${r}`,
            onChange: (l) => {
              var E, A;
              (A = (E = o.props).onChange) == null || A.call(E, l), p ? n == null || n(l ? o.props.value ?? null : null) : f(l, r);
            }
          })
        )
      )
    }
  );
};
xe.Item = se;
export {
  me as ACCORDION_FADE_DURATION_MS,
  xe as Accordion,
  de as useToggle
};
